import { render, staticRenderFns } from "./InertiaViz.vue?vue&type=template&id=6e5492e2&scoped=true"
import script from "./InertiaViz.vue?vue&type=script&lang=js"
export * from "./InertiaViz.vue?vue&type=script&lang=js"
import style0 from "./InertiaViz.vue?vue&type=style&index=0&id=6e5492e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5492e2",
  null
  
)

export default component.exports